export default __webpack_public_path__ + "static/media/photo_jade.18b49a9b.jpg";